import { render, staticRenderFns } from "./Incestgamesbody.vue?vue&type=template&id=b8a2601c&scoped=true&"
import script from "./Incestgamesbody.vue?vue&type=script&lang=js&"
export * from "./Incestgamesbody.vue?vue&type=script&lang=js&"
import style0 from "./Incestgamesbody.vue?vue&type=style&index=0&id=b8a2601c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8a2601c",
  null
  
)

export default component.exports